
import React, { useState, useEffect } from 'react';
import './styles/ReaderAppsPicker.scss';
import useBatchStateUpdate from 'hooks/useBatchStateUpdate';
import { isEmptyObject } from 'lib/helpers';
import readerApps from './readerApps.json';

const READER_ATTR = {
    format: {
        'Adobe DRM': 'adobeDRM',
        'Readium': 'readium',
        'Social DRM': 'socialDRM'
    },
    device: {
        'Desktop': 'desktop',
        'Mobile/Tablet': 'mobile'
    },
    platform: {
        'Apple iOS': 'ios',
        'Apple MacOS': 'mac',
        'Windows': 'windows',
        'Android': 'android'
    }
};

export default function ReaderAppsPicker() {
    const [readerFormat, setReaderFormat] = useState(null);
    const [readerDevice, setReaderDevice] = useState(null);
    const [readerPlatfrom, setReaderPlatform] = useState(null);
    const [showResults, setShowResults] = useState(false);
    const [downloadLinks, setDownloadLinks] = useState(null);
    const [showDownloadHasStarted, setShowDownloadHasStarted] = useState(false);
    const batch = useBatchStateUpdate();

    useEffect(() => {
        if (readerFormat && readerDevice && readerPlatfrom) {
            const key = `${readerFormat}-${readerDevice}-${readerPlatfrom}`;
            const res = getDownloadLinksByKey(key);
            batch(() => {
                setShowResults(true);
                if (res) {
                    setDownloadLinks(res);
                }
            });
        }
        else {
            setShowResults(false);
            setDownloadLinks(null);
        }
    }, [readerFormat, readerDevice, readerPlatfrom, batch]);

    function getDownloadLinksByKey(key) {
        let dl = {};
        Object.keys(readerApps).forEach((k) => {
            if (readerApps[k].compatibles.indexOf(key) !== -1) {
                dl = { ...dl, ...readerApps[k].apps };
            }
        });
        if (isEmptyObject(dl)) { return null; }
        return dl;
    }

    function handleReset() {
        batch(() => {
            setReaderFormat(null);
            setReaderDevice(null);
            setReaderPlatform(null);
            setShowDownloadHasStarted(false);
        });
    }

    return (
        <>
            <p className="f17 fw-bold">Reader Apps</p>
            {(() => {
                if (showResults) {
                    return (
                        <div>
                            <ul>
                                <li>
                                    {(() => {
                                        if (downloadLinks !== null) {
                                            return (
                                                <>
                                                    <p>You can read your downloaded book with the following reader apps:</p>
                                                    {
                                                        (showDownloadHasStarted)
                                                            ? <p className="fw-bold">Your Book is Ready To Download...</p>
                                                            : <div className="apps margin-top-30">
                                                                {Object.keys(downloadLinks).map((k) => (
                                                                    <a
                                                                        href={downloadLinks[k]}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        key={k}
                                                                        onClick={() => {
                                                                            setShowDownloadHasStarted(true);
                                                                            return true;
                                                                        }}
                                                                    ><span>{k}</span></a>
                                                                ))}
                                                            </div>
                                                    }
                                                </>
                                            );
                                        }
                                        else {
                                            return (<p>Sorry no reader apps were found for this format.</p>);
                                        }
                                    })()}

                                </li>
                            </ul>
                            <span className="reset-link" onClick={() => handleReset()}>Reset</span>
                        </div>
                    );
                }
                else {
                    return (
                        <ul>
                            <li>
                                <p>Pick Format</p>
                                <div className="d-flex">
                                    {Object.keys(READER_ATTR.format).map((k) => {
                                        return (
                                            <span key={k} className={((readerFormat === READER_ATTR.format[k]) ? 'selected' : '')} onClick={() => setReaderFormat(READER_ATTR.format[k])}>{k}</span>
                                        );
                                    })}
                                </div>
                            </li>
                            <li>
                                <p>Device Type</p>
                                <div className="d-flex">
                                    {Object.keys(READER_ATTR.device).map((k) => {
                                        return (
                                            <span key={k} className={((readerDevice === READER_ATTR.device[k]) ? 'selected' : '')} onClick={() => setReaderDevice(READER_ATTR.device[k])}>{k}</span>
                                        );
                                    })}
                                </div>
                            </li>
                            <li>
                                <p>Platform</p>
                                <div className="d-flex">
                                    {Object.keys(READER_ATTR.platform).map((k) => {
                                        const isMobile = (READER_ATTR.platform[k] === 'ios' || READER_ATTR.platform[k] === 'android');
                                        if (readerDevice === 'mobile') {
                                            if (isMobile) {
                                                return (
                                                    <span key={k} className={((readerPlatfrom === READER_ATTR.platform[k]) ? 'selected' : '')} onClick={() => setReaderPlatform(READER_ATTR.platform[k])}>{k}</span>
                                                );
                                            }
                                        }
                                        else {
                                            if (!isMobile) {
                                                return (
                                                    <span key={k} className={((readerPlatfrom === READER_ATTR.platform[k]) ? 'selected' : '')} onClick={() => setReaderPlatform(READER_ATTR.platform[k])}>{k}</span>
                                                );
                                            }
                                        }

                                    })}
                                </div>
                            </li>
                        </ul>
                    );
                }
            })()}
        </>
    );
}